import { action } from 'typesafe-actions';
import {DataStatusActionTypes, DataStatusContract} from './types';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const getDataStatusRequest = () => action(DataStatusActionTypes.FETCH_STATUS_REQUEST);
export const getDataStatusSuccess = (dataStatus: DataStatusContract[]) => action(DataStatusActionTypes.FETCH_STATUS_SUCCESS, dataStatus);
export const getDataStatusFailure = (message: string) => action(DataStatusActionTypes.FETCH_STATUS_FAILURE, message);
